import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

import { API_URL } from "./env";
import { captureBackendError } from "./observa-capture";

export const authClient = createAuthClient({
  baseURL: `${API_URL}/auth`,
  plugins: [magicLinkClient()],
  fetchOptions: {
    credentials: "include",
    // Surface auth transport faults to observa. BetterAuth folds non-ok
    // responses into its result type rather than throwing, so a broken
    // /auth mount (the 2026-06 outage 404'd /trpc/auth/*) would otherwise
    // leave no trace. Expected auth 4xx (401/403) are filtered inside
    // captureBackendError.
    onError: (context) => {
      captureBackendError(context.response.url || `${API_URL}/auth`, {
        status: context.response.status,
        statusText: context.response.statusText,
        cause: context.error,
      });
    },
  },
});

export const { useSession, signIn, signUp, signOut } = authClient;

// Web sends the session cookie automatically (credentials: "include"),
// so non-better-auth requests (tRPC) need nothing extra here. The native
// build overrides this in auth-client.native.ts, where the session lives
// in SecureStore and must be replayed manually. Returning "" keeps the
// tRPC fetch a no-op on web.
export function getSessionCookie(): string {
  return "";
}
